export default __webpack_public_path__ + "static/media/bg.48710c48.jpg";